const common = {
  gregorianToJalali(date, exportType = "date") {
    // exportType = "date" || "dateTime" || "year"
    date = new Date(date);
    var gy = date.getFullYear();
    var gm = date.getMonth() + 1;
    var gd = date.getDate();

    var g_d_m, jy, jm, jd, gy2, days;
    g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
    gy2 = gm > 2 ? gy + 1 : gy;
    days =
      355666 +
      365 * gy +
      parseInt((gy2 + 3) / 4) -
      parseInt((gy2 + 99) / 100) +
      parseInt((gy2 + 399) / 400) +
      gd +
      g_d_m[gm - 1];
    jy = -1595 + 33 * parseInt(days / 12053);
    days %= 12053;
    jy += 4 * parseInt(days / 1461);
    days %= 1461;
    if (days > 365) {
      jy += parseInt((days - 1) / 365);
      days = (days - 1) % 365;
    }
    if (days < 186) {
      jm = 1 + parseInt(days / 31);
      jd = 1 + (days % 31);
    } else {
      jm = 7 + parseInt((days - 186) / 30);
      jd = 1 + ((days - 186) % 30);
    }

    switch (exportType) {
      case "date":
        return jy + "/" + jm + "/" + jd;
      case "dateTime":
        return (
          jy +
          "/" +
          ("0" + jm).slice(-2) +
          "/" +
          ("0" + jd).slice(-2) +
          " " +
          date.toLocaleTimeString("en-US", { hour12: false })
        );
      case "year":
        return jy;
    }
  },

  isValidValue(value) {
    if (value === undefined || value === null || isNaN(value) || value === "")
      return false;

    return true;
  },

  parseJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  },
};

export default common;
